var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2593 16L22.7611 1.48273C22.7704 1.21347 22.9914 1 23.2608 1H25.9277C26.1958 1 26.4162 1.21143 26.4273 1.47928L26.9259 13.5M1.26389 17.8586L9.59722 13.3943C9.93031 13.2159 10.3333 13.4572 10.3333 13.8351V17.1649C10.3333 17.5428 10.7364 17.7841 11.0694 17.6057L18.9306 13.3943C19.2636 13.2159 19.6667 13.4572 19.6667 13.8351V17.1649C19.6667 17.5428 20.0697 17.7841 20.4028 17.6057L28.2639 13.3943C28.597 13.2159 29 13.4572 29 13.8351V28.5C29 28.7761 28.7761 29 28.5 29H1.5C1.22386 29 1 28.7761 1 28.5V18.2994C1 18.115 1.10141 17.9457 1.26389 17.8586Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7778 4H26.4075",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.07e75cd64a55d55425cf5532f1f89761.svg";
export { ForwardRef as ReactComponent };